/**
 * Format file size for display
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
}

/**
 * Format a timestamp as `yyyy-mm-dd HH:mm:ss` (24-hour) in `timeZone` — the
 * browser's own by default — whatever the browser's language. `withZone`
 * appends the zone abbreviation for that instant, e.g. `CEST` or `GMT-4`.
 */
export function formatDateTime(
  value: string | Date,
  options: { timeZone?: string; withZone?: boolean } = {}
): string {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: options.timeZone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
    ...(options.withZone && { timeZoneName: 'short' }),
  }).formatToParts(new Date(value));
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';
  const text = `${part('year')}-${part('month')}-${part('day')} ${part('hour')}:${part('minute')}:${part('second')}`;
  return options.withZone ? `${text} ${part('timeZoneName')}` : text;
}
